<p-dialog id="account-profile" [modal]="true" [closable]="false" [showHeader]="true" [styleClass]="'detail-modal'"
  [(visible)]="visible" (onHide)="onHide()" class="modal-dialog" [style]="{ width: '800px', 'min-height': '300px'}">
  <ng-template pTemplate="header">
    <div class="flex justify-content-center align-items-center w-full">
      <h4 class="title m-0">{{ 'complete_profile_title' | translate }}</h4>
    </div>
  </ng-template>

  <div class="mb-4 infobox">
    <div class="flex align-items-start">
      <i class="pi pi-exclamation-triangle text-yellow-400 mr-4 mt-1"></i>
      <div>
        <div class="box-title mb-2">{{ 'complete_profile_infobox_title' | translate }}</div>
        <p class="box-text mr-2 line-height-3">
          {{ 'complete_profile_infobox_description_1' | translate }}
        </p>
        <p class="box-text mr-2 line-height-3 mt-2">
          {{ 'complete_profile_infobox_description_2' | translate }}
          <strong>{{ 'complete_profile_infobox_deadline' | translate }}</strong>{{
          'complete_profile_infobox_description_3' | translate
          }}
        </p>
      </div>
    </div>
  </div>

  <form class="px-4 pt-6 pb-4" [formGroup]="personalInformationForm" (ngSubmit)="onConfirm()">
    <div class="grid p-fluid">
      @if (isFullNameInvalid) {
      <div class="col field">
        <input id="firstName" type="text" pInputText formControlName="firstName"
          placeholder="{{'complete_profile_name' | translate}}">
        @if (personalInformationForm.get('firstName')?.invalid && personalInformationForm.get('firstName')?.touched) {
        <p id="firstName-error" class="error">{{ 'complete_profile_field_required' | translate }}</p>
        }

        @if (isPersonalInformationInvalid) {
        <p id="firstName-backend-error" class="error"> {{ 'complete_profile_personal_information_backend_error' |
          translate }} </p>
        }
      </div>
      <div class="col field">
        <input id="firstSurname" type="text" pInputText formControlName="firstSurname"
          placeholder="{{'complete_profile_lastName' | translate}}">
        @if (personalInformationForm.get('firstSurname')?.invalid &&
        personalInformationForm.get('firstSurname')?.touched) {
        <p id="firstSurname-error" class="error">{{ 'complete_profile_field_required' | translate }}</p>
        }

        @if (isPersonalInformationInvalid) {
        <p id="firstSurname-backend-error" class="error"> {{ 'complete_profile_personal_information_backend_error' |
          translate }} </p>
        }
      </div>
      <div class="col field">
        <input id="secondSurname" type="text" pInputText formControlName="secondSurname"
          placeholder="{{'complete_profile_secondSurname' | translate}}">

        @if (isPersonalInformationInvalid && personalInformationForm.get('secondSurname')?.value) {
        <p id="secondSurname-backend-error" class="error"> {{ 'complete_profile_personal_information_backend_error' |
          translate }} </p>
        }
      </div>
      }
    </div>

    @if (!hasPersonalInformation?.termsAccepted) {
    <div class="grid p-fluid pt-6 pl-4">
      <div class="flex align-items-center">
        <input type="checkbox" formControlName="termsAccepted" id="termsConditions" class="mr-4" />
        <label for="termsConditions" class="m-0">
          <span>{{ 'complete_profile_accept_the_terms' | translate }}</span>
          <a id="termsConditionsLink" class="pl-1" target="_blank"
            href="https://www.voxelgroup.net/general-terms/bavelpay/">
            {{ 'complete_profile_terms_and_conditions' |translate }}
          </a>
          <span> {{ 'complete_profile_terms_and_conditions_security' | translate }}</span>
          <a id="securityLink" class="pl-1" target="_blank" href="https://www.voxelgroup.net/general-terms/bavelpay/">
            {{ 'complete_profile_terms_and_conditions_security_link' | translate }}
          </a>
        </label>
      </div>
      @if (personalInformationForm.get('termsAccepted')?.invalid &&
      personalInformationForm.get('termsAccepted')?.touched) {
      <div class="pl-4">
        <p id="termsConditions-error" class="error">{{ 'complete_profile_field_required' | translate }}</p>
      </div>
      }
    </div>
    }

  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2 px-4">
      <div class="flex align-items-center pl-4">
        <button id="confirmButton" [disabled]="!isValidCompleteProfileComponent" (click)="onConfirm()">{{
          'complete_profile_confirm' | translate
          }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

@if (showSpinner) {
<p-blockUI [blocked]="showSpinner">
  <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" animationDuration=".5s">
  </p-progressSpinner>
</p-blockUI>
}